import { FormControlLabelProps as MuiFormControlLabelProps } from '@mui/material/FormControlLabel';
import { StyledFormControlLabel } from './styles';

export enum LabelOffsetTypes {
  'small' = 'small',
  'medium' = 'medium',
}

export interface FormControlLabelProps extends MuiFormControlLabelProps {
  labelOffset?: keyof typeof LabelOffsetTypes;
}

export default function FormControlLabel(props: FormControlLabelProps) {
  return <StyledFormControlLabel {...props} />;
}
